import { getStyle } from "../getStyle";

export function isHiddenWithinTree (elem: HTMLElement, el?: HTMLElement) {

  elem = el || elem;

  // Inline style trumps all
  return elem.style.display === "none" ||
    elem.style.display === "" &&
    getStyle(elem, "display") === "none";
}